

































import Vue from "vue";
import BitGo from "./Experiences/BitGo.vue";
import Cyclica from "./Experiences/Cyclica.vue";
import HypotenuseLabs from "./Experiences/HypotenuseLabs.vue";
import Tucows from "./Experiences/Tucows.vue";
import Stratus360 from "./Experiences/Stratus360.vue";
import TDLab from "./Experiences/TDLab.vue";
import ZurApps from "./Experiences/ZurApps.vue";

export default Vue.extend({
  name: "experiences",
  components: {
    BitGo,
    Cyclica,
    HypotenuseLabs,
    Tucows,
    Stratus360,
    TDLab,
    ZurApps,
  },
});
